import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/take';
import { Subject } from 'rxjs/Subject';

import { Trip, SelectObj } from '../../models/trip';
import { Address } from '../../models/address';
import { AddressBrw } from '../address/address_brw'
import { AuthProvider } from '../../providers/auth/auth';

@Component({
    selector: 'page-tripfrm',
    templateUrl: 'trip_frm.html',
    host: {
        '(document:keypress)': 'handleKeyboardEvent($event)'
      }        
})
export class TripFrm {

    tripFrm: FormGroup
    action: number
    key: string
    actionDescription: string = 'Unknown Action'
    submitAttempt: boolean = false
    multiAdd: boolean = false

    via_addressLookup: string
    via_address$: Observable<Address[]>
    via_addressSub: any
    via_addressStartAt$ = new Subject<string>()
    via_addressFound = 0
    via_addressFoundLen = 0
    via_addressFoundString = ''

    start_addressLookup: string
    start_address$: Observable<Address[]>
    start_addressSub: any
    start_addressStartAt$ = new Subject<string>()
    start_addressFound = 0
    start_addressFoundLen = 0
    start_addressFoundString = ''

    end_addressLookup: string
    end_address$: Observable<Address[]>
    end_addressSub: any
    end_addressStartAt$ = new Subject<string>()
    end_addressFound = 0
    end_addressFoundLen = 0
    end_addressFoundString = ''

    vehicle$: Observable<SelectObj[]>
    vehicle: SelectObj
    vehicleCollectionRef: AngularFirestoreCollection<SelectObj>
    
    tripCollectionRef: AngularFirestoreCollection<Trip>
    tripRef: AngularFirestoreDocument<Trip>
    tripDoc = {} as Trip

    constructor(public alertCtrl: AlertController, public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, private afs: AngularFirestore, public authData: AuthProvider){
        this.tripCollectionRef = afs.collection<Trip>('trips')
        this.vehicleCollectionRef = afs.collection<SelectObj>('vehicles')
        this.tripRef = afs.doc<Trip>('trips/' + navParams.get('key'))
        this.buildForm() // with empty tripDoc
    }

    ngOnInit() {
        this.action = this.navParams.get('action')
        if (this.action == 1){
            this.tripDoc = {} as Trip
            this.actionDescription = 'Insert'
            this.afs.doc<SelectObj>('settings/vehicle').valueChanges().take(1).subscribe(vehicle => {
                this.vehicle = vehicle
                this.afs.collection<Trip>('trips', ref => ref
                .limit(1)
                .where('uid', '==', this.authData.authState.uid)
                .where('vehicle.value','==',this.vehicle.value)
                .orderBy('date', 'desc')
                .orderBy('end_mileage','desc'))
                .valueChanges()
                .take(1)
                .map(val => val[0])
                .subscribe(lastTrip => {
                    if (lastTrip != undefined){
                        this.tripDoc.date = lastTrip.date
                        this.tripDoc.start_mileage = lastTrip.end_mileage
                        this.tripDoc.start_address = lastTrip.end_address
                    }
                    this.getAddressLookup(lastTrip.end_address, 'start')
                    this.end_addressLookup = ''
                    this.end_addressFound = 0
                    this.via_addressLookup = ''
                    this.via_addressFound = 0
                    this.buildForm()
                })
            })            
        } else {
            if (this.action == 2){
                this.actionDescription = 'Change'
            } else {
                if (this.action == 3){
                    this.actionDescription = 'Delete'
                }
            }
            this.tripRef.valueChanges().take(1).subscribe(val => {
                this.tripDoc = val
                this.vehicle = val.vehicle
                this.getAddressLookup(val.start_address, 'start')
                this.getAddressLookup(val.end_address, 'end')
                this.getAddressLookup(val.via_address, 'via')
                this.buildForm()
            })
        }
        this.vehicle$ = this.vehicleCollectionRef.valueChanges()
        this.subscribeLookups()
    }

    handleKeyboardEvent(event: KeyboardEvent) {
        // console.log(event);
        // if (event.key == '+') this.insert();
    }
    
    buildForm(){
        console.log('tripdoc: ', this.tripDoc)
        this.tripFrm = this.formBuilder.group({
            date: [this.tripDoc.date, Validators.required],
            start_mileage: [this.tripDoc.start_mileage, Validators.required],
            end_mileage: [this.tripDoc.end_mileage, Validators.required],
            private_trip: [this.tripDoc.private_trip],
            private_dist: [this.tripDoc.private_dist],
            remarks: [this.tripDoc.remarks]
        })                                
    }
  
    compareFn(option1: any, option2: any){
        return option1.value === option2.value;
    }
    
    addressPub(subject): Observable<Address[]> {
        return subject
        .switchMap(startAt => this.afs.collection<Address>('addresses', ref => ref
        .limit(2).orderBy('code')
        .startAt(startAt.toUpperCase()).endAt(startAt.toUpperCase() + 'Z'))
        .snapshotChanges().map(addresses => {
            return addresses.map(address => {
            const data = address.payload.doc.data() as Address
            const id = address.payload.doc.id
            return {id, ...data}
        })}))
    }

    subscribeLookups(){
        this.addressPub(this.start_addressStartAt$).subscribe(res => {
            this.start_addressFound = res.length
            if (this.start_addressFound == 1) {
                this.tripDoc.start_address = res[0].id // set key
                this.start_addressLookup = res[0].name // set on search entry to full name
                this.start_addressFoundLen = res[0].name.length
                this.start_addressFoundString = res[0].name
            }
        })
        this.addressPub(this.end_addressStartAt$).subscribe(res => {
            this.end_addressFound = res.length
            if (this.end_addressFound == 1) {
                this.tripDoc.end_address = res[0].id // set key
                this.end_addressLookup = res[0].name // set on search entry to full name
                this.end_addressFoundLen = res[0].name.length
                this.end_addressFoundString = res[0].name
            }
        })
        this.addressPub(this.via_addressStartAt$).subscribe(res => {
            this.via_addressFound = res.length
            if (this.via_addressFound == 1) {
                this.tripDoc.via_address = res[0].id // set key
                this.via_addressLookup = res[0].name // set on search entry to full name
                this.via_addressFoundLen = res[0].name.length
                this.via_addressFoundString = res[0].name
            }
        })        
    }

    onBlur(blurField) {
        // console.log('blur: ' + blurField)
        switch (blurField) {
            case 'end_mileage':
                // console.log('start: ', this.tripFrm.value.start_mileage, this.tripFrm.controls['start_mileage'])
                if (!this.tripFrm.value.end_mileage || !this.tripFrm.value.start_mileage) break
                let len_end = this.tripFrm.value.end_mileage.toString().length
                let len_start = this.tripFrm.value.start_mileage.toString().length
                if (len_end <= len_start) {
                    setTimeout( () => {
                        this.tripFrm.controls['end_mileage'].setValue(Number(this.tripFrm.value.start_mileage.toString().slice(0,(len_start-len_end)) + this.tripFrm.value.end_mileage.toString()))
                    }, 100) // don't know why...
                }
                break;
        
            default:
                break;
        }    
    }

    getAddressLookup(key, field){
        if ((key == undefined) || (key == '')) return
        this.afs.doc<Address>('addresses/' + key).valueChanges()
        .take(1)
        .subscribe(address => {
            if (address == undefined) return
            if (field == 'start'){
                this.start_addressLookup = address.name
                this.start_addressFound = 1
                return
            }
            if (field == 'end'){
                this.end_addressLookup = address.name
                this.end_addressFound = 1
                return
            }
            if (field == 'via'){
                this.via_addressLookup = address.name
                this.via_addressFound = 1
                return
            }
        })    
    }

    lookupAddress(e: any, type){
        let value = e.target.value + ''
        if (type == 'start'){
            if ((e.target.value == undefined) || (e.target.value == '')) {
                this.start_addressStartAt$.next('ZZZZZZZZZZ')
                this.start_addressFound = 0
            } else {
                if ((this.start_addressFound != 1) || ((this.start_addressFound == 1) && (value.length < this.start_addressFoundLen))){
                    this.start_addressStartAt$.next(e.target.value)
                } else {
                    this.start_addressLookup = this.start_addressFoundString
                }
            }
            return
        }
        if (type == 'end'){
            if ((e.target.value == undefined) || (e.target.value == '')) {
                this.end_addressStartAt$.next('ZZZZZZZZZZ')
                this.end_addressFound = 0
            } else {
                if ((this.end_addressFound != 1) || ((this.end_addressFound == 1) && (value.length < this.end_addressFoundLen))){
                    this.end_addressStartAt$.next(e.target.value)                    
                } else {
                    this.end_addressLookup = this.end_addressFoundString
                }
            }
            return
        }
        if (type == 'via'){
            if ((e.target.value == undefined) || (e.target.value == '')) {
                this.via_addressStartAt$.next('ZZZZZZZZZZ')
                this.via_addressFound = 0
            } else {
                if ((this.via_addressFound != 1) || ((this.via_addressFound == 1) && (value.length < this.via_addressFoundLen))){
                    this.via_addressStartAt$.next(e.target.value)                    
                } else {
                    this.via_addressLookup = this.via_addressFoundString
                }
            }
            return
        }
    }
    
    selectAddress(type, e?){
        if ((e != undefined) && (e.key != "ArrowRight")) return;
        if (type == 'start') {
            var callbackPromise = new Promise((resolve, reject) => {
                this.navCtrl.push(AddressBrw, {searchString: this.start_addressLookup, action: 4, resolve: resolve});
              }).then(data => {
                this.start_addressLookup = data + ''
                this.start_addressStartAt$.next(this.start_addressLookup)
              })
            return    
        }
        if (type == 'end') {
            var callbackPromise = new Promise((resolve, reject) => {
                this.navCtrl.push(AddressBrw, {searchString: this.end_addressLookup, action: 4, resolve: resolve});
              }).then(data => {
                this.end_addressLookup = data + ''
                this.end_addressStartAt$.next(this.end_addressLookup)
              })
            return    
        }
        if (type == 'via') {
            var callbackPromise = new Promise((resolve, reject) => {
                this.navCtrl.push(AddressBrw, {searchString: this.via_addressLookup, action: 4, resolve: resolve});
              }).then(data => {
                this.via_addressLookup = data + ''
                this.via_addressStartAt$.next(this.via_addressLookup)
              })
            return    
        }
    }

    addVehicle(){
        let prompt = this.alertCtrl.create({
            title: 'New vehicle',
            message: "Add new vehicle to choose from",
            inputs: [
              {
                name: 'vehicle',
                placeholder: 'Vehicle identifier/license'
              },
            ],
            buttons: [
              {
                text: 'Cancel',
                handler: data => {
                }
              },
              {
                text: 'Add',
                handler: data => {
                  this.vehicleCollectionRef.add({text: data.vehicle, value:data.vehicle})
                }
              }
            ]
          });
        prompt.present();
    }

    formValid(){
        if ((!this.tripFrm.valid) || 
            (this.start_addressFound != 1) ||
            (this.end_addressFound != 1) ||
            (this.vehicle == undefined)) return false;
        return true
    }

    save(){
        this.submitAttempt = true
        if ((this.action < 3) && (!this.formValid())) return
        this.tripFrm.value["uid"] = this.authData.authState.uid             // not in formBuilder
        this.tripFrm.value["start_address"] = this.tripDoc.start_address    // standalone on screen (not in formBuilder)
        this.tripFrm.value["end_address"] = this.tripDoc.end_address        // standalone on screen (not in formBuilder)
        this.tripFrm.value["via_address"] = this.tripDoc.via_address == undefined ? null : this.tripDoc.via_address       // standalone on screen (not in formBuilder)
        this.tripFrm.value["vehicle"] = this.vehicle                        // standalone on screen (not in formBuilder)
        this.tripFrm.value["start_mileage"] = Number(this.tripFrm.value["start_mileage"])
        this.tripFrm.value["end_mileage"] = Number(this.tripFrm.value["end_mileage"])
        this.tripFrm.value["private_dist"] = Number(this.tripFrm.value["private_dist"])
        if (this.action == 1){
            console.log('tripfrm: ', this.tripFrm)
            this.tripCollectionRef.add(this.tripFrm.value)
            if (this.multiAdd) {
                this.ngOnInit()
                return
            }
        } else {
            if (this.action == 2){
                this.tripRef.update(this.tripFrm.value)
            } else {
                if (this.action == 3){
                    this.tripRef.delete()
                }
            }
        }
        this.navCtrl.pop()
    }

}



// WEBPACK FOOTER //
// ./src/pages/trip/trip_frm.ts